import { projectApi } from '@highlight-cp/project-api';

import { useGetCurrentProject } from '../use-get-current-project';

/**
 * ### useBYOCStatusByCurrentProject
 *
 * @description
 * Hook that checks if BYOC (Bring Your Own Community) is enabled for the current project's organization.
 * Fetches the entitlement definition and returns the BYOC status.
 * Useful for the admin app to view the correct BYOC per-project instead of the BYOC state for Highlight.
 *
 * @returns Object containing isBYOCEnabled boolean and isLoading state
 */
export const useBYOCStatusByCurrentProject = () => {
  const { data: currentProject } = useGetCurrentProject();
  const orgId = currentProject?.orgId;

  const { data: entitlement, isLoading } =
    projectApi.useGetOrganizationsByOrgIdEntitlementDefnQuery(
      { orgId: orgId ?? 0 },
      { skip: !orgId },
    );

  const isBYOCEnabled = entitlement?.byoc?.isEnabled === true;

  return {
    isBYOCEnabled,
    isLoading,
  };
};
